// utils/pdfUtils.js
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const handlePDFDownload = (
  data,
  columns,
  reportTitle = "Report",
  landscape
) => {
  let doc;
  if (landscape) {
    const pageWidth = 410;
    const pageHeight = 210;
    doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [pageWidth, pageHeight],
    });
  } else {
    doc = new jsPDF();
  }

  const filteredColumns = columns.filter((col) => col.key !== "View" && col.key !== "Action" && col.key !== "SAV");

  // Extract only the titles for table headers
  const columnTitles = filteredColumns.map((col) => col.title);

  const rows = data.map((record) =>
    filteredColumns.map((column) => record[column.dataIndex] || "N/A")
  );

  doc.text(reportTitle, 14, 10);

  doc.autoTable({
    head: [columnTitles],
    body: rows,
    startY: 20,
    theme: "grid",
    styles: {
      fontSize: 7,
      cellPadding: 1,
    },
    headStyles: {
      fillColor: "#b83d3d",
      textColor: [255, 255, 255],
      fontSize: 9,
    },
    columnStyles: columns.reduce((acc, col, index) => {
      acc[index] = { cellWidth: "wrap" };
      return acc;
    }, {}),
    margin: { left: 10, right: 10 },
    tableWidth: "auto",
    scaleFactor: 0.8,
  });

  doc.save(`${reportTitle}.pdf`);
};

// utils/excelUtils.js

export const exportToExcel = (data, fileName = "table_data.xlsx") => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, fileName);
};

// utils/printUtils.js
// export const handlePrint = (data, columns, reportTitle = "Report") => {
//   if (data.length === 0) {
//     alert("No data available for printing.");
//     return;
//   }

//   const printTab = window.open("", "_blank");

//   const styles = [...document.styleSheets]
//     .map((sheet) => {
//       try {
//         return [...sheet.cssRules].map((rule) => rule.cssText).join("");
//       } catch (e) {
//         return "";
//       }
//     })
//     .join("");



//   let tableHtml = `<table border="1" style="width: 100%; border-collapse: collapse;">`;

//   const filteredColumns = columns.filter((col) => col.key !== "View" && col.key !== "Action" && col.key !== "SAV");

//   // Add table headers from the columns
//   tableHtml += "<thead><tr>";
//   filteredColumns.forEach((col) => {
//     tableHtml += `<th style="padding: 3px; text-align: left; border: 1px solid black; width: auto">${col.title}</th>`;
//   });
//   tableHtml += "</tr></thead>";

//   // Add table rows from data
//   tableHtml += "<tbody>";
//   data.forEach((row) => {
//     tableHtml += "<tr style='border: 1px solid black;'>";
//     filteredColumns.forEach((col) => {
//       const cellValue = row[col.dataIndex];
//       tableHtml += `<td style="padding: 3px; border: 1px solid black;">${cellValue != null ? cellValue : ""
//         }</td>`;
//     });
//     tableHtml += "</tr>";
//   });
//   tableHtml += "</tbody></table>";

//   // Open the print window and write the content
//   printTab.document.write("<html><head><title>Print</title>");
//   printTab.document.write(`<style>${styles}</style>`);
//   printTab.document.write("</head><body>");
//   printTab.document.write(`<h2>${reportTitle}</h2>`);
//   printTab.document.write(tableHtml);
//   printTab.document.write("</body></html>");

//   printTab.document.close();


//   printTab.onafterprint = () => printTab.close();
//   printTab.print();
// };

export const handlePrint = (data, columns, reportTitle = "Report") => {
  if (!data || data.length === 0) {
    alert("No data available for printing.");
    return;
  }

  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  const filteredColumns = columns.filter(
    (col) => col.key !== "View" && col.key !== "Action" && col.key !== "SAV"
  );

  let tableHtml = `
    <table border="1" style="width:100%; border-collapse: collapse;">
      <thead>
        <tr>
  `;

  filteredColumns.forEach((col) => {
    tableHtml += `<th style="padding:6px; border:1px solid black;">${col.title}</th>`;
  });

  tableHtml += `</tr></thead><tbody>`;

  data.forEach((row) => {
    tableHtml += "<tr>";
    filteredColumns.forEach((col) => {
      const value = row[col.dataIndex] ?? "";
      tableHtml += `<td style="padding:6px; border:1px solid black;">${value}</td>`;
    });
    tableHtml += "</tr>";
  });

  tableHtml += "</tbody></table>";

  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>${reportTitle}</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          table { font-size: 12px; }
          h2 { margin-bottom: 20px; }
        </style>
      </head>
      <body>
        <h2>${reportTitle}</h2>
        ${tableHtml}
      </body>
    </html>
  `);

  printWindow.document.close();

  // 🔥 KEY FIX: wait before printing
  setTimeout(() => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  }, 500); // 300–500ms required in many browsers
};

